import React, { useState } from "react";
import { Button, Typography, } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Cartproduct from "../../User/components/Cart_product";
import no_products from "../../User/assets/Nocart-image.svg";
import Catalogueorder from "../../User/components/Catalogue_order";
import instance from "../../Utils/api";
import { useGlobalContext } from "../../context/Context";
import Header from "../layouts/Header";


const Mycart = () => {
  const { fetchCartLength } = useGlobalContext()
  // const [currentTabIndex, setCurrentTabIndex] = useState(0); //usestate for tab section
  // const [showCatalogueorder, setshowCatalogueorder] = useState(false); // State to show order summary
  // const [showPickupOrder, setShowPickupOrder] = useState(false); // State to show pickup order
  const [data, setData] = useState(null);
  const [selectedData, setSelectedData] = useState([]);
  const [placeOrder, setPlaceOrder] = useState(false);
  // const [searchparams] = useSearchParams();
  // const orderids = searchparams.get("orderids");

  // useEffect(() => {
  //   const idsArray = orderids?.split(",")?.map(id => id.trim());
  //   console.log("idsArray", idsArray);

  //   const filtered = data?.filter(item => idsArray?.includes(item?.design_id?._id));
  //   console.log("filtered", filtered);

  //   setSelectedData(filtered);
  // }, [orderids, data]);

  // Function to go to the tabs
  // const handleTabChange = (e, tabIndex) => {
  //     setCurrentTabIndex(tabIndex);
  //     setshowCatalogueorder(false); // Reset when switching tabs
  //     setShowPickupOrder(false); // Reset when switching tabs
  // };
  const handleCheckboxChange = (event, data) => {
    if (event.target.checked) {
      // Add all items if "Select All" is checked
      setSelectedData((prevIds) => {
        // Avoid duplicates by merging and removing duplicates
        const allIds = [
          ...prevIds,
          ...data.filter(
            (item) => !prevIds.some((id) => id?._id === item?._id)
          ),
        ];
        return allIds;
      });
    } else {
      // Remove all items if "Select All" is unchecked
      setSelectedData((prevIds) =>
        prevIds.filter(
          (selectedId) => !data.some((item) => item?._id === selectedId?._id)
        )
      );
    }
  };

  const getCartData = async () => {
    try {
      const response = await instance.get("/Cart/getCart");

      setData(response?.data?.data?.items);
      fetchCartLength();

    } catch (error) {
      console.log(error);
    }
  };

  useState(() => {
    getCartData();
  }, []);

  return (
    <React.Fragment>
      <Header />
      <section className="mycart" >
        <div className="mycart-title">
          {/* <Button onClick={() => navigate(-1)}>
            <KeyboardBackspaceIcon />
            Back
          </Button> */}
          <Typography variant="h4">My cart</Typography>
          {/* Conditionally render "Select All" checkbox if more than one product is available */}
          {(data?.length > 1) & (placeOrder === false) ? (
            <div className="product-selectall">
              <Typography variant="h6">
                Select All
                <Checkbox
                  onChange={(event) => handleCheckboxChange(event, data)}
                  checked={data?.every((item) =>
                    selectedData?.some((id) => id?._id === item?._id)
                  )}
                />
              </Typography>
            </div>
          ) : null}
        </div>
        {/* <section className='mycar-tabs'>
                    <div className='tabs-title'>
                        <Tabs value={currentTabIndex} onChange={handleTabChange}>
                            <Tab label='Catalogue order' />
                            <Tab label='Pickup Order' />
                        </Tabs>
                    </div>
                </section> */}
        {/* {!showCatalogueorder && !showPickupOrder ? ( */}
        {/* <> */}
        {/* {currentTabIndex === 0 && ( */}
        {placeOrder === false && (
          <React.Fragment>
            {data?.length === 0 ? (
              <React.Fragment>
                <div className="cart-no-items">
                  <img src={no_products} alt="no_products" />
                  <Typography>
                    You can see it here after you add the items to your cart
                  </Typography>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <React.Fragment>
                  <div className="mycart-details-container">
                    {data?.map((order, index) => (
                      <Cartproduct
                        key={index} // Always provide a unique key when mapping in React
                        data={order}
                        // showCheckbox={data?.length > 1} // Pass condition to show checkbox
                        showCheckbox1={data?.length > 1} // Pass condition to show checkbox
                        setSelectedData={setSelectedData}
                        getCartData={getCartData}
                        selectedData={selectedData}
                      />
                    ))}
                  </div>
                </React.Fragment>
                {/* <div className='mycart-buttons'>
                                <Button className='remove-btn'>Remove</Button>
                                <Button className='order-btn'>Order</Button>
                            </div> */}
                <div className="ordered-details">
                  <div className="ordered-content">
                    <Typography variant="h5">Order details</Typography>
                    <span className="order-separate"></span>
                    <Typography variant="h6">
                      Total <span>{selectedData?.length} items</span>
                    </Typography>
                    <Button sx={{ backgroundColor: selectedData?.length === 0 ? "#9C9C9C" : '#E37B00' }} onClick={() => setPlaceOrder(true)} disabled={selectedData?.length === 0}>
                      Place Your Order
                    </Button>
                  </div>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        <>
          {placeOrder === true && (
            <Catalogueorder selectedData={selectedData} />
          )}
        </>
        {/* )}
                         {currentTabIndex === 1 && (
                             <React.Fragment>
                                 <section className='pickup-order'>
                                     <Grid container sx={{ display: 'flex', alignItems: "center", justifyContent: "center" }} >
                                         <React.Fragment>
                                             <Uploadeddesigns />
                                         </React.Fragment>
                                         <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8 }}>
                                             <div className="pickup-order-btn">
                                                 <Button onClick={() => setShowPickupOrder(true)}>Place your order</Button>
                                            </div>
                                         </Grid>
                                     </Grid>
                                 </section>
                             </React.Fragment>
                         )} */}
        {/* </>
                 ) : showCatalogueorder ? (
                     If showOrderSummary is true, render the Catalogue Order Summary
                     <Catalogueorder />
                 ) : showPickupOrder ? (
                     If showPickupOrder is true, render the Pickup Order Summary
                     <Pickuporder />
                 ) : null} */}
        {/* </section> */}
      </section>
    </React.Fragment>
  );
};

export default Mycart;
